import { Box, Heading, Flex } from '@chakra-ui/react';
import { OrganizationsTable } from '../../components/organizations-table/organizations-table.comp';

export function OrganizationsList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Organizations</Heading>
            </Flex>
            <OrganizationsTable />
        </Box>
    );
}
